export default __webpack_public_path__ + "static/screen_2_02-41fe33fb12c10a298e428dc1ca956a34.svg";